import classNames from "classnames";
import styles from "./style.module.scss";
import SkeletonLoader from "shared/components/common/skeleton";

interface ListItemSkeletonProps {
  count?: number;
  className?: string;
  showIcon?: boolean;
}

const ListItemSkeleton = ({
  count = 1,
  className,
  showIcon = true,
}: ListItemSkeletonProps) => {
  return (
    <>
      {Array.from({ length: count }).map((_, index) => (
        <div
          key={index}
          className={classNames(
            styles.listItemSkeleton,
            "flex gap-2",
            className,
          )}
        >
          {showIcon && (
            <div className={styles.iconSkeleton}>
              <SkeletonLoader className={styles.icon} />
            </div>
          )}
          <div className={styles.contentSkeleton}>
            <SkeletonLoader className={styles.titleSkeleton} />
            <SkeletonLoader className={styles.descriptionSkeleton} />
          </div>
        </div>
      ))}
    </>
  );
};

export default ListItemSkeleton;
